import { AfterContentInit, Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { NotificationService } from "../../services/notification.service";
import { ProjectService } from "../../services/project.service";
import { TotallandAcquistionModelComponent } from "./modal/totalLandacquistion.component";

@Component({
  selector: "app-private-negotiation",
  templateUrl: "private-negotiation.component.html",
  styleUrls: ["private-negotiation.component.css"],
})
export class PrivateNegotiationComponent implements OnInit, AfterContentInit {
  private readonly nonNegativeDecimalValidators = [
    Validators.required,
    Validators.pattern(/^\d+(\.\d+)?$/),
  ];

  villageid: string = "";
  actualPNdataId: number | null = null;
  fundDepositedataId: number | null = null;
  fundpaiddataId: number | null = null;

  ////////////////// Form Groups ////////////////////////
  form_PN!: FormGroup;
  form_actual_PN!: FormGroup;
  form_fund_deposited!: FormGroup;
  form_fund_paid!: FormGroup;

  ////////// Project Information ///ks/////////
  projectInfo: Record<string, any> | null = null;

  dataActualPN: Array<Record<string, any>> = [];
  datafundDeposition: Array<Record<string, any>> = [];
  datafundpaid: Array<Record<string, any>> = [];
  oldVillageDetail: Record<string, any> = {};
  oldVillageDetail2: Record<string, any> = {};

  editActualPnData: boolean = false;
  editfunddeposite: boolean = false;
  editfundpaid: boolean = false;
  showFormfield: boolean = true;
  completionMessageJMS: boolean = false;

  // file upload
  fileToUpload: File | null = null;

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private projectService: ProjectService,
    private notification: NotificationService
  ) {}

  ngOnInit(): void {
    this.villageid = localStorage.getItem("village_id") || "";

    ///////////////////// Getting Table Data ////////////////////////
    this.retreiveTableData();

    this.form_PN = this.fb.group({
      total_area_aquired_pn: new FormControl(
        null,
        this.nonNegativeDecimalValidators
      ),
      total_compensation_pn: new FormControl(
        null,
        this.nonNegativeDecimalValidators
      ),
    });
    this.form_actual_PN = this.fb.group({
      actual_area_aquired: new FormControl(
        null,
        this.nonNegativeDecimalValidators
      ),
      actual_area_aquired_date: new FormControl(null, Validators.required),
      document: new FormControl(null, Validators.required),
    });
    this.form_fund_deposited = this.fb.group({
      pn_fund_deposition: new FormControl(
        null,
        this.nonNegativeDecimalValidators
      ),
    });
    this.form_fund_paid = this.fb.group({
      pn_fund_distribution: new FormControl(
        null,
        this.nonNegativeDecimalValidators
      ),
    });
  }

  normalizeNumericControl(form: FormGroup, controlName: string): void {
    const control = form.get(controlName);
    if (!control) return;

    const rawValue = String(control.value ?? "");
    let numericValue = rawValue.replace(/[^0-9.]/g, "");
    const firstDecimalIndex = numericValue.indexOf(".");

    if (firstDecimalIndex !== -1) {
      numericValue =
        numericValue.slice(0, firstDecimalIndex + 1) +
        numericValue.slice(firstDecimalIndex + 1).replace(/\./g, "");
    }

    if (numericValue.startsWith(".")) {
      numericValue = `0${numericValue}`;
    }

    if (numericValue !== rawValue) {
      control.setValue(numericValue, { emitEvent: false });
    }
  }

  isNumericControlInvalid(form: FormGroup, controlName: string): boolean {
    const control = form.get(controlName);
    return !!control && control.invalid && (control.dirty || control.touched);
  }

  private validateForm(form: FormGroup): boolean {
    if (form.invalid) {
      form.markAllAsTouched();
      return false;
    }

    return true;
  }

  // file upload logic

  handleFileInput(files: FileList | null): void {
    this.fileToUpload = files && files.length ? files[0] : null;
    console.log(this.fileToUpload, "what is this");
  }

  retreiveTableData(): void {
    this.projectService.getPNactualarea(this.villageid).subscribe((res) => {
      console.log(res);
      this.dataActualPN.push(...res);
    });
    this.projectService.getFundDeposition(this.villageid).subscribe((res) => {
      console.log(res);
      this.datafundDeposition.push(...res);
    });
    this.projectService.getFundpaid(this.villageid).subscribe((res) => {
      console.log(res);
      this.datafundpaid.push(...res);
    });
    this.projectService.retriveVilldetails(this.villageid).subscribe((res) => {
      this.oldVillageDetail2 = res;
      console.log(this.oldVillageDetail, "old");
    });
    this.projectService
      .getIndividualVillageDetail(this.villageid)
      .subscribe((res) => {
        this.oldVillageDetail = res;
        console.log(this.oldVillageDetail, "old");
      });
  }

  //  on save of form_PN form

  totallandacquired(): void {
    if (!this.validateForm(this.form_PN)) return;

    console.log(this.form_PN.value, "form value");
    this.projectService
      .updateCompletionStatus(this.villageid, this.form_PN.value)
      .subscribe((res) => {
        console.log(res, "total add data response response");
        this.projectService
          .getIndividualVillageDetail(this.villageid)
          .subscribe((res) => {
            this.oldVillageDetail = res;
            console.log(this.oldVillageDetail, "villages data");
            this.showFormfield = true;
            this.notification.showNotification(
              "top",
              "right",
              "success",
              "Data Posted successfully"
            );
          });
      });
  }

  edittotalData(): void {
    this.form_PN.patchValue({
      total_area_aquired_pn: this.oldVillageDetail["total_area_aquired_pn"],
      total_compensation_pn: this.oldVillageDetail["total_compensation_pn"],
    });
    this.showFormfield = false;
  }

  // Actual PN add edit retrive delete api integration

  actuallandacquired(): void {
    if (!this.validateForm(this.form_actual_PN)) return;

    // let bodyData = [{
    //     actual_area_aquired: this.form_actual_PN.value.actual_area_aquired,
    //     actual_area_aquired_date: this.form_actual_PN.value.actual_area_aquired_date,
    //     village: parseInt(this.villageid)
    // }]
    const bodyData = new FormData();
    bodyData.append(
      "actual_area_aquired",
      String(this.form_actual_PN.value.actual_area_aquired ?? "")
    ),
      bodyData.append(
        "actual_area_aquired_date",
        String(this.form_actual_PN.value.actual_area_aquired_date ?? "")
      ),
      bodyData.append("village", this.villageid);
    if (this.fileToUpload) {
      bodyData.append("document", this.fileToUpload);
    }
    this.projectService.postPNactualarea(bodyData).subscribe((res) => {
      console.log(res);
      this.projectService
        .getIndividualVillageDetail(this.villageid)
        .subscribe((res) => {
          this.oldVillageDetail = res;
          console.log(this.oldVillageDetail, "villages data");
          this.projectService.getPNactualarea(this.villageid).subscribe((res) => {
            console.log(res);
            this.dataActualPN =res;
          });
          // this.showFormfield=true;
        });
      // this.dataActualPN.push(...res);
      this.form_actual_PN.reset();
      this.notification.showNotification(
        "top",
        "right",
        "success",
        "Data Posted successfully"
      );
    });
  }

  editactualPNData(id: number): void {
    this.actualPNdataId = id;
    this.editActualPnData = true;
    this.projectService
      .retrivePNactualarea(this.actualPNdataId)
      .subscribe((res) => {
        console.log(res);
        this.form_actual_PN.patchValue({
          actual_area_aquired: res.actual_area_aquired,
          actual_area_aquired_date: res.actual_area_aquired_date,
        });
      });
  }

  onUpdateactualPNData(): void {
    if (!this.validateForm(this.form_actual_PN)) return;

    const data = {
      actual_area_aquired: this.form_actual_PN.value.actual_area_aquired,
      actual_area_aquired_date:
        this.form_actual_PN.value.actual_area_aquired_date,
      village: this.villageid,
    };
    this.projectService
      .updatePNactualarea(this.actualPNdataId, data)
      .subscribe((res) => {
        console.log(res, "update res");
        this.projectService.getPNactualarea(this.villageid).subscribe((res) => {
          // console.log(res)
          this.projectService
            .getIndividualVillageDetail(this.villageid)
            .subscribe((res) => {
              this.oldVillageDetail = res;
              console.log(this.oldVillageDetail, "villages data");
              // this.showFormfield=true;
            });
          this.dataActualPN = [];
          this.dataActualPN.push(...res);
          this.form_actual_PN.reset();
          this.editActualPnData = false;
          this.notification.showNotification(
            "top",
            "right",
            "success",
            "Data Updated successfully"
          );
        });
      });
  }

  deleteactualPNData(id: number): void {
    this.projectService.deletePNactualarea(id).subscribe((res) => {
      console.log(res, "delete res");
      this.projectService.getPNactualarea(this.villageid).subscribe((res) => {
        // console.log(res)
        this.projectService
          .getIndividualVillageDetail(this.villageid)
          .subscribe((res) => {
            this.oldVillageDetail = res;
            console.log(this.oldVillageDetail, "villages data");
            // this.showFormfield=true;
          });
        this.dataActualPN = [];
        this.dataActualPN.push(...res);
        this.notification.showNotification(
          "top",
          "right",
          "success",
          "Data Deleted successfully"
        );
      });
    });
  }

  //End Of Actual PN add edit retrive delete api integration

  //start of Fund deposited with CALA under PN api integration

  onAddfundDeposite(): void {
    if (!this.validateForm(this.form_fund_deposited)) return;

    const bodyData =
      {
        pn_fund_deposition: this.form_fund_deposited.value.pn_fund_deposition,
        village: parseInt(this.villageid, 10),
      }
    ;
    this.projectService.postFundDeposition(bodyData).subscribe((res) => {
      console.log(res, "add fund deposition res");
      this.projectService
        .getIndividualVillageDetail(this.villageid)
        .subscribe((res) => {
          this.oldVillageDetail = res;
          console.log(this.oldVillageDetail, "villages data");
          // this.showFormfield=true;
        });
        // this.datafundDeposition = []
        this.projectService.getFundDeposition(this.villageid).subscribe((res) => {
          console.log(res);
          this.datafundDeposition=res;
        });
      // this.datafundDeposition.push(...res);
      this.form_fund_deposited.reset();
      this.notification.showNotification(
        "top",
        "right",
        "success",
        "Data Posted successfully"
      );
    });
  }

  editfundDepositeData(id: number): void {
    this.fundDepositedataId = id;
    this.projectService
      .retrivefundDeposite(this.fundDepositedataId)
      .subscribe((res) => {
        console.log(res);
        this.editfunddeposite = true;
        this.form_fund_deposited.patchValue({
          pn_fund_deposition: res.pn_fund_deposition,
        });
      });
  }

  onUpdatefundDepositeData(): void {
    if (!this.validateForm(this.form_fund_deposited)) return;

    const data = {
      pn_fund_deposition: this.form_fund_deposited.value.pn_fund_deposition,
      village: parseInt(this.villageid, 10),
    };
    this.projectService
      .updatefundDeposite(this.fundDepositedataId, data)
      .subscribe((res) => {
        console.log(res, "update res");
        this.editfunddeposite = false;
        this.projectService
          .getFundDeposition(this.villageid)
          .subscribe((res) => {
            // console.log(res);
            this.projectService
              .getIndividualVillageDetail(this.villageid)
              .subscribe((res) => {
                this.oldVillageDetail = res;
                console.log(this.oldVillageDetail, "villages data");
                this.showFormfield = true;
              });
            this.datafundDeposition = [];
            this.datafundDeposition.push(...res);
            this.form_fund_deposited.reset();
            // this.editActualPnData = false;
            this.notification.showNotification(
              "top",
              "right",
              "success",
              "Data Updated successfully"
            );
          });
      });
  }

  deletefundDepositeData(id: number): void {
    this.projectService.deletefundDeposite(id).subscribe((res) => {
      console.log(res, "delete res");
      this.projectService.getFundDeposition(this.villageid).subscribe((res) => {
        // console.log(res);
        this.projectService
          .getIndividualVillageDetail(this.villageid)
          .subscribe((res) => {
            this.oldVillageDetail = res;
            console.log(this.oldVillageDetail, "villages data");
            // this.showFormfield=true;
          });
        this.datafundDeposition = [];
        this.datafundDeposition.push(...res);
        // this.form_fund_deposited.reset();
        // this.editActualPnData = false;
        this.notification.showNotification(
          "top",
          "right",
          "success",
          "Data Deleted successfully"
        );
      });
    });
  }

  //end of Fund deposited with CALA under PN api integration

  //start of  Fund paid to land owners under PN api integration

  onAddfundpaid(): void {
    if (!this.validateForm(this.form_fund_paid)) return;

    const bodyData =
      {
        pn_fund_distribution: this.form_fund_paid.value.pn_fund_distribution,
        village: parseInt(this.villageid, 10),
      }
    ;
    this.projectService.postFundpaid(bodyData).subscribe((res) => {
      console.log(res, "add fund deposition res");
      // this.datafundpaid.push(...res);
      this.projectService
        .getIndividualVillageDetail(this.villageid)
        .subscribe((res) => {
          this.oldVillageDetail = res;
          console.log(this.oldVillageDetail, "villages data");
          // this.showFormfield=true;
        });
        this.projectService.getFundpaid(this.villageid).subscribe((res) => {
          console.log(res);
          this.datafundpaid=res;
        });
      this.form_fund_paid.reset();
      this.notification.showNotification(
        "top",
        "right",
        "success",
        "Data Posted successfully"
      );
    });
  }

  editfundpaidData(id: number): void {
    this.fundpaiddataId = id;
    this.projectService
      .retrivefundpaid(this.fundpaiddataId)
      .subscribe((res) => {
        console.log(res);
        this.editfundpaid = true;
        this.form_fund_paid.patchValue({
          pn_fund_distribution: res.pn_fund_distribution,
        });
      });
  }

  onUpdatefundpaidData(): void {
    if (!this.validateForm(this.form_fund_paid)) return;

    const data = {
      pn_fund_distribution: this.form_fund_paid.value.pn_fund_distribution,
      village: parseInt(this.villageid, 10),
    };
    this.projectService
      .updatefundpaid(this.fundpaiddataId, data)
      .subscribe((res) => {
        console.log(res, "update res");
        this.editfundpaid = false;
        this.projectService.getFundpaid(this.villageid).subscribe((res) => {
          console.log(res);
          this.projectService
            .getIndividualVillageDetail(this.villageid)
            .subscribe((res) => {
              this.oldVillageDetail = res;
              console.log(this.oldVillageDetail, "villages data");
              // this.showFormfield=true;
            });
          this.datafundpaid = [];
          this.form_fund_paid.reset();
          this.datafundpaid.push(...res);
          this.notification.showNotification(
            "top",
            "right",
            "success",
            "Data Updated successfully"
          );
        });
      });
  }

  deletefundpaidData(id: number): void {
    this.projectService.deletefundpaid(id).subscribe((res) => {
      console.log(res, "delete res");
      this.projectService.getFundpaid(this.villageid).subscribe((res) => {
        console.log(res);
        this.projectService
          .getIndividualVillageDetail(this.villageid)
          .subscribe((res) => {
            this.oldVillageDetail = res;
            console.log(this.oldVillageDetail, "villages data");
            // this.showFormfield=true;
          });
        this.datafundpaid = [];
        this.form_fund_paid.reset();
        this.datafundpaid.push(...res);
        this.notification.showNotification(
          "top",
          "right",
          "success",
          "Data Deleted successfully"
        );
      });
    });
  }

  //end of  Fund paid to land owners under PN api integration

  ngAfterContentInit(): void {
    const projectInformation = localStorage.getItem("project_info");
    this.projectInfo = projectInformation ? JSON.parse(projectInformation) : null;
    console.log(this.projectInfo);
  }

  // open dialbox

  openJMSDialog(): void {
    // this.projectService.villageID.next(this.villageid);
    const dialogRef = this.dialog.open(TotallandAcquistionModelComponent, {
      width: "500px",
      height: "400px",
      data: {},
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      //   this.hideForm();
    });
  }
}
